var render, staticRenderFns
import script from "./bigdetail.vue?vue&type=script&lang=js"
export * from "./bigdetail.vue?vue&type=script&lang=js"
import style0 from "./bigdetail.vue?vue&type=style&index=0&id=7a020ed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a020ed2",
  null
  
)

export default component.exports